import { types } from 'mobx-state-tree';

const FilterOption = types.model('FilterOption', {
  name: types.string,
  value: types.string,
  count: types.maybeNull(types.number),
});

export default FilterOption;
